import { HttpResponse } from '@angular/common/http';
import { AfterContentInit, Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTable } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import 'moment/locale/fr';
import { filter, finalize } from 'rxjs/operators';
import { MeasureReference } from 'src/app/domain/GS/measure-reference';
import { Agency } from 'src/app/domain/agency';
import { ClientMeasure } from 'src/app/domain/client-measure';
import { Competence } from 'src/app/domain/competence';
import { DisponibiliteClient } from 'src/app/domain/disponibilite-client';
import { EFrequency } from 'src/app/domain/enum/frequency';
import { EInterventionStatus } from 'src/app/domain/enum/intervention-status';
import { EMeasureParentType } from 'src/app/domain/enum/measure-parent-type';
import { ETimeSlot } from 'src/app/domain/enum/time-slot';
import { EZoneUsage } from 'src/app/domain/enum/zone-usage';
import { Intervention } from 'src/app/domain/intervention';
import { Strategy } from 'src/app/domain/strategy';
import { User } from 'src/app/domain/user';
import { ENavigationRoute } from 'src/app/model/enum/navigation-route';
import { AgencyService } from 'src/app/services/GS/agency.service';
import { MeasureReferenceService } from 'src/app/services/GS/measure-reference.service';
import { ClientMeasureService } from 'src/app/services/client-measure.service';
import { InterventionService } from 'src/app/services/intervention.service';
import { MasterCompetenceService } from 'src/app/services/mastercompetence.service';
import { SpecificityService } from 'src/app/services/specificity.service';
import { StrategyService } from 'src/app/services/strategy.service';
import { UserService } from 'src/app/services/user.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { AlternateContactBoxComponent } from 'src/app/tools/ui/alternate-contact-box/alternate-contact-box.component';
import { ComplementaryMeasurenBoxDialog } from 'src/app/tools/ui/complementary-measure-box/complementary-measure-box';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { EditTextBoxDialog } from 'src/app/tools/ui/edit-text-box/edit-text-box';
import { LoadingTask } from 'src/app/tools/ui/loading-task';
import { MapSelectionMeasurenBoxDialog } from 'src/app/tools/ui/map-selection-box/map-selection-box';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { NumberBoxDialog } from 'src/app/tools/ui/number-box/number-box';
import { StandardMeasurenBoxDialog } from 'src/app/tools/ui/standard-measure-box/standard-measure-box';
import { MeasureEditionBoxDialog } from 'src/app/tools/ui/standard-measure-edition-box/measure-edition-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { BaseComponent } from '../base/base.component';
import { EAreaMapType } from 'src/app/domain/enum/area-map-type';
import { AreaMap } from 'src/app/domain/GS/area-map';
import { AreaMapService } from 'src/app/services/GS/area-map.service';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';

@Component({
    selector: 'app-order',
    templateUrl: './order.component.html',
    styleUrls: ['./order.component.scss'],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'fr-FR' },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderComponent extends BaseComponent implements OnInit, AfterContentInit {
    ETimeSlot = ETimeSlot;
    EZoneUsage = EZoneUsage;
    EAreaMapType = EAreaMapType;
    EMeasureParentType = EMeasureParentType;
    @ViewChild('table') table: MatTable<any>;
    @ViewChild('ctable') ctable: MatTable<any>;
    displayedColumns = this.IsDispatch ? ['color', 'measure', 'name', 'edi', 'battery', 'express', 'hasFan', 'accredited', 'actions'] : ['color', 'measure', 'name', 'battery', 'express', 'actions'];
    cdisplayedColumns = this.IsDispatch ? ['color', 'plan', 'mesure', 'edi', 'description', 'battery', 'express', 'hasFan', 'actions'] : ['color', 'plan', 'mesure', 'description', 'battery', 'express', 'actions'];

    StrategyId: number;
    MeasureId: number;
    IsCreation: boolean = true;
    Model: Intervention = new Intervention();

    MeasureList: ClientMeasure[] = [];
    // SelectedMeasureList: ClientMeasure[] = [];
    // Orderable
    AvailableMeasureList: ClientMeasure[] = [];
    StandardMeasureList: ClientMeasure[] = [];
    ComplementaryMeasureList: ClientMeasure[] = [];
    // EXOTIC
    MassifMeasureList: ClientMeasure[] = [];
    LingetteMeasureList: ClientMeasure[] = [];
    EauMeasureList: ClientMeasure[] = [];
    AdductionMeasureList: ClientMeasure[] = [];
    //
    GenericList: ClientMeasure[] = [];

    WithBattery: boolean;
    WithExpressDelay: boolean;
    AvailableContactList: User[] = [];

    Strategy: Strategy;
    public minInterventionTime;
    public maxInterventionTime;

    public WithStrictHours: boolean;

    public MeasureReferenceFullList: MeasureReference[] = [];

    public MasterCompetenceList: Competence[] = [];
    AvailableMasterCompetenceList: Competence[] = []; // Full list - already picked
    // public SelectedCompetenceList: Competence[];
    compCtrl = new UntypedFormControl();

    AgencyList: Agency[] = [];
    Specificity: string = '';

    FullGenericList: ClientMeasure[] = [];
    AvailableGenericList: ClientMeasure[] = [];
    SelectedGroup: ClientMeasure
    AvailableMeasureByGroupList: ClientMeasure[] = [];

    SelectedGeneric: ClientMeasure;

    MinDate: Date;

    IsProcess(measureReferenceCode: string) {
        if (!this.Strategy.IsFDX)
            return measureReferenceCode === 'Je' || measureReferenceCode === 'Jv' || measureReferenceCode === 'K' || measureReferenceCode === 'I'
        return measureReferenceCode === 'SEPTP1' ||
            measureReferenceCode === 'SEPTP2' ||
            measureReferenceCode === 'CNEPO' ||
            measureReferenceCode === 'SEDFP' ||
            measureReferenceCode === 'SPRMPC' ||
            measureReferenceCode === 'CNEPE' ||
            measureReferenceCode === 'CNEPV' ||
            measureReferenceCode === 'AC' ||
            measureReferenceCode === 'CEJT'
    }

    constructor(
        protected coreData: CoreData,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        private snackBar: MatSnackBar,
        private measureService: ClientMeasureService,
        private interventionService: InterventionService,
        private strategyService: StrategyService,
        private userService: UserService,
        private agencyService: AgencyService,
        private measureReferenceService: MeasureReferenceService,
        private masterCompetenceService: MasterCompetenceService,
        private areaMapService: AreaMapService,
        private specificityService: SpecificityService,
        private loadingTask: LoadingTask,
        private _adapter: DateAdapter<any>,
        @Inject(MAT_DATE_LOCALE) private _locale: string
    ) {
        super(coreData)
        this._locale = 'fr';
        this._adapter.setLocale(this._locale);
    }

    ngOnInit(): void {
    }

    ngAfterContentInit(): void {
        this.StrategyId = this.route.snapshot.params['id'];
        this.Model.Id = this.route.snapshot.params['interventionId'];

        const measureId = Number(this.route.snapshot.params['measureId']);

        this.getStrategy();

        this.getOrderable(measureId);
        this.getContactList();

        this.getAllMeasureReferenceList();
        this.getMasterCompetenceList();

        if (this.Model.Id) {
            this.IsCreation = false;
            setTimeout(() => this.getIntervention(), 100);
        }
        if (this.IsDispatch) {
            this.getAllAgency();
        }
        this.getAvailableGenericList()
        // this.Model.RequiredOn = new Date();
        // this.Model.RequiredOn.setDate(this.Model.RequiredOn.getDate() + 1);

        this.computeMinDateForOrder()
    }

    getFrequencyLabel(freq: EFrequency) {
        return this.Strategy.IsFDX ? StringConverter.getFDXFrequencyName(freq) : StringConverter.getFrequencyName(freq)
    }

    /** Si on n'est le week-end alors on ne peut plannifier qu'a partir du Mardi suivant
     *  Sinon en semaine a peut commander pour le lendemain avant 15h
     */
    computeMinDateForOrder() {
        if (this.IsDispatch)
            return;

        if (Temporal.Now.plainDateISO().dayOfWeek == 6 || Temporal.Now.plainDateISO().dayOfWeek == 7)
            this.MinDate = this.convertTemporalToDate(Temporal.Now.plainDateISO().add(Temporal.Now.plainDateISO().dayOfWeek == 6 ? { days: 3 } : { days: 2 }))
        else
            this.MinDate = this.convertTemporalToDate(Temporal.Now.plainDateISO().add(Temporal.Now.plainDateTimeISO().hour > 15 ? { days: 2 } : { days: 1 }))
    }

    getStrategy() {
        this.strategyService.getStrategyById(this.StrategyId).subscribe(x => {
            this.Strategy = x;
            this.getSpecificityForMyClient(this.Strategy.Portfolio.ClientCode);
        });
    }

    getAvailableGenericList() {
        this.measureService.getGenericList().subscribe((x: any) => {
            this.FullGenericList = x;
            this.AvailableGenericList = _.uniqBy(x, y => y.GroupName);
        })
    }

    getMeasureOfThatGroup() {
        this.AvailableMeasureByGroupList = this.FullGenericList.filter(x => x.GroupName === this.SelectedGroup.GroupName);
        this.SelectedGeneric = this.AvailableMeasureByGroupList[0];
    }

    getSpecificityForMyClient(clientCode: string) {
        this.specificityService.getSpecificityForClient(clientCode).subscribe(x => {
            this.Specificity = x;
        });
    }

    getAllAgency() {
        this.agencyService.getByPartner().subscribe(x => {
            this.AgencyList = x;
        })
    }

    getAllMeasureReferenceList() {
        this.measureReferenceService.getAllMeasureReferences().subscribe(x => {
            this.MeasureReferenceFullList = x;
        })
    }

    getMasterCompetenceList() {
        this.masterCompetenceService.getMasterCompetenceList().subscribe(x => {
            this.MasterCompetenceList = this.AvailableMasterCompetenceList = x;
        })
    }

    getIntervention() {
        this.interventionService.getInterventionById(this.Model.Id).subscribe(x => {
            this.Model = x;
            this.StandardMeasureList = x.MeasureList.filter(x =>
                x.IsComplementary === false &&
                (x.ParentType !== EMeasureParentType.Massif &&
                    x.ParentType !== EMeasureParentType.Eau &&
                    x.ParentType !== EMeasureParentType.Lingette &&
                    x.ParentType !== EMeasureParentType.AdductionAir &&
                    x.ParentType !== EMeasureParentType.Generic)
            );

            this.MassifMeasureList = x.MeasureList.filter(x => x.ParentType === EMeasureParentType.Massif);
            this.EauMeasureList = x.MeasureList.filter(x => x.ParentType === EMeasureParentType.Eau);
            this.LingetteMeasureList = x.MeasureList.filter(x => x.ParentType === EMeasureParentType.Lingette);
            this.AdductionMeasureList = x.MeasureList.filter(x => x.ParentType === EMeasureParentType.AdductionAir);
            this.ComplementaryMeasureList = x.MeasureList.filter(x => x.IsComplementary);
            this.GenericList = x.MeasureList.filter(x => x.ParentType === EMeasureParentType.Generic)
            this.GenericList.forEach(y => {
                y.localID = (_.max(this.GenericList.map(y => y.localID)) ?? 0) + 1
            })
            if (this.Model.DisponibiliteClientList[0] && this.Model.DisponibiliteClientList[0].From) {
                this.WithStrictHours = true;
                this.setMinTime();
                this.setMaxTime();
            } else {
                this.Model.DisponibiliteClientList.push(new DisponibiliteClient())
            }

            this.Model.MassifAreaMapIdList = this.Model.MassifAreaMapTerrainList?.map(x => x.MassifAreaMapId);
            this.Model.LingetteAreaMapIdList = this.Model.LingetteAreaMapTerrainList?.map(x => x.LingetteAreaMapId);

            this.table.renderRows();
            this.ctable.renderRows();
        });
    }

    getContactList() {
        this.userService.getSiteContactList(this.StrategyId).subscribe(x => {
            this.AvailableContactList = x;
        });
    }

    getOrderable(measureId: number) {
        this.measureService.getOrderableMeasureList(this.StrategyId).subscribe(x => {
            this.AvailableMeasureList = x;

            let mr = this.AvailableMeasureList.find(x => x.SamplingId === measureId)
            if (mr) {

                this.AvailableMeasureList.filter(x => x.SamplingId === measureId || mr.ParentName === x.ParentName).forEach(y => {

                    if (mr.IsComplementary)
                        this.ComplementaryMeasureList.push(y);
                    else
                        this.StandardMeasureList.push(y);
                    // this.Model.MeasureList.push(this.AvailableMeasureList.find(x => x.SamplingId === measureId));

                    if (this.IsProcess(y.MeasureReferenceCode)) {

                        this.updateExoticMeasureList(EMeasureParentType.Massif, this.MassifMeasureList, this.MassifMeasureList.length + 1);

                        if (this.EauMeasureList.length === 0)
                            this.updateExoticMeasureList(EMeasureParentType.Eau, this.EauMeasureList, this.EauMeasureList.length + 1);
                    }
                })

                this.table.renderRows();
            }
        });
    }

    getProcessDisclaimer(m: ClientMeasure) {
        if (this.IsProcess(m.MeasureReferenceCode))
            return '(1)'
        return ''
    }

    openMapSelection(m: ClientMeasure) {
        const dialogRef = this.dialog.open(MapSelectionMeasurenBoxDialog, {
            data: { strategyId: this.StrategyId },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: AreaMap) => {
            if (result) {
                m.AreaMapName = result.Legend;
            }
        });
    }

    openMapSelectionForLingetteOrMassif(type: EAreaMapType) {
        const dialogRef = this.dialog.open(MapSelectionMeasurenBoxDialog, {
            data: {
                strategyId: this.StrategyId,
                type: type,
                excludedAreaMap: type === EAreaMapType.PlanDeLingette ? this.Model.LingetteAreaMapTerrainList : this.Model.MassifAreaMapTerrainList
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: AreaMap) => {
            if (result) {
                if (type === EAreaMapType.PlanDeLingette) {
                    this.Model.LingetteAreaMapTerrainList.push(result);
                    this.Model.LingetteAreaMapIdList.push(result.Id);
                } else if (type === EAreaMapType.PlanMassif) {
                    this.Model.MassifAreaMapTerrainList.push(result);
                    this.Model.MassifAreaMapIdList.push(result.Id);
                }
            }
        });
    }

    removeLingette(areaMap: AreaMap) {
        _.remove(this.Model.LingetteAreaMapTerrainList, x => x === areaMap);
        _.remove(this.Model.LingetteAreaMapIdList, x => x === (areaMap.LingetteAreaMapId ?? areaMap.Id));
    }

    removeMassif(areaMap: AreaMap) {
        _.remove(this.Model.MassifAreaMapTerrainList, x => x === areaMap);
        _.remove(this.Model.MassifAreaMapIdList, x => x === (areaMap.MassifAreaMapId ?? areaMap.Id));
    }

    openContactDialog() {
        const dialogRef = this.dialog.open(AlternateContactBoxComponent, {
            data: {
                clientCode: this.Strategy.Portfolio.ClientCode,
                alreadyAddedContactList: this.AvailableContactList ?? []
            },
            width: '555px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.userService.addAlternateContact(result, this.StrategyId).subscribe(x => {
                    this.AvailableContactList.push(result);
                    this.Model.SiteContact = result;
                    NotificationManager.handleSuccess('Contact ajouté !', this.snackBar);
                })
            }
        });
    }

    openStandardBox() {
        const dialogRef = this.dialog.open(StandardMeasurenBoxDialog, {
            data: {
                strategy: this.Strategy,
                alreadyPicked: this.StandardMeasureList,
                orderableList: this.AvailableMeasureList
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ClientMeasure[]) => {
            if (result) {
                result.forEach(x => x.IsComplementary = false);

                if (this.IsProcess(result[0].MeasureReferenceCode)) {
                    result.forEach(x => {
                        this.updateExoticMeasureList(EMeasureParentType.Massif, this.MassifMeasureList, this.MassifMeasureList.length + 1);
                    })
                    if (this.EauMeasureList.length === 0)
                        this.updateExoticMeasureList(EMeasureParentType.Eau, this.EauMeasureList, this.EauMeasureList.length + 1);
                }

                this.StandardMeasureList.push(...result)
                this.table.renderRows();
            }
        });
    }

    openMeasureEditionBox(measure: ClientMeasure, withAccredited?: boolean) {
        const dialogRef = this.dialog.open(MeasureEditionBoxDialog, {
            data: {
                measure: measure,
                withAccredited: withAccredited
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ClientMeasure[]) => {
            if (result) {

            }
        });
    }

    openComplementaryBox(measure?: ClientMeasure) {
        const dialogRef = this.dialog.open(ComplementaryMeasurenBoxDialog, {
            data: {
                strategyId: this.StrategyId,
                strategyType: this.Strategy.Type
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: ClientMeasure[]) => {
            if (result) {
                let next = this.ComplementaryMeasureList.filter(y => y.MeasureReferenceCode === result[0].MeasureReferenceCode).length;
                for (let i = 0; i < result.length; i++, next++) {
                    result[i].IsComplementary = true;
                    result[i].localID = next;

                    console.log('next ' + next + 'i =>' + i)
                    console.log('R0 ->' + result[0].localID)
                };

                if (this.IsProcess(result[0].MeasureReferenceCode)) {
                    result.forEach(x => {
                        this.updateExoticMeasureList(EMeasureParentType.Massif, this.MassifMeasureList, this.MassifMeasureList.length + 1);
                    })
                    if (this.EauMeasureList.length === 0)
                        this.updateExoticMeasureList(EMeasureParentType.Eau, this.EauMeasureList, this.EauMeasureList.length + 1);
                }

                this.ComplementaryMeasureList.push(...result)
                this.ctable.renderRows();
            }
        });
    }

    openEditTextBoxForEDINumber(measure: ClientMeasure) {
        const dialogRef = this.dialog.open(EditTextBoxDialog, {
            data: { title: 'EDI Analysis Number', text: measure.EDIAnalysisNumber ?? '' },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) {
                measure.EDIAnalysisNumber = result;
            }
        });
    }

    getColorForPoseDeposeOP(measure: ClientMeasure) {
        if (measure.ParentType === EMeasureParentType.Process)
            return "chartreuse !important";
        if (measure.IsDepose) {
            return "slateblue !important";
        }
        return "cadetblue !important";
    }

    getLabelForPoseDeposeOP(measure: ClientMeasure) {
        if (measure.ParentType === EMeasureParentType.Process)
            return "OP";
        if (measure.IsDepose) {
            return "Dépose";
        }
        return "Pose";
    }

    getExoticMeasureCodeByType(type: EMeasureParentType) {
        switch (type) {
            case EMeasureParentType.AdductionAir:
                return "HGMesureAdductionAir"
            case EMeasureParentType.Eau:
                return "HGMesureEau"
            case EMeasureParentType.Lingette:
                return "HGMesureLingette"
            case EMeasureParentType.Massif:
                return "HGMesureMassif"
        }
    }

    getFDXExoticMeasureCodeByType(type: EMeasureParentType) {
        switch (type) {
            case EMeasureParentType.AdductionAir:
                return "HFMesureAdductionAir"
            case EMeasureParentType.Eau:
                return "HFMesureEau"
            case EMeasureParentType.Lingette:
                return "HFMesureLingette"
            case EMeasureParentType.Massif:
                return "HFMesureMassif"
        }
    }

    updateExoticMeasureList(
        measureType: EMeasureParentType,
        measureList: ClientMeasure[],
        targetCount: number
    ): void {
        measureList.splice(targetCount);

        const measuresToAdd = targetCount - measureList.length;
        if (measuresToAdd > 0) {
            Array.from({ length: measuresToAdd }, () => {
                const measure = new ClientMeasure();
                measure.MeasureReferenceCode = this.Strategy.IsFDX
                    ? this.getFDXExoticMeasureCodeByType(measureType)
                    : this.getExoticMeasureCodeByType(measureType);
                measure.ParentType = measureType;
                return measure;
            }).forEach(measure => measureList.push(measure));
        }
    }

    openExoticMeasureCountDialog(measureType: EMeasureParentType, measureList: ClientMeasure[], measureName: string) {
        const dialogRef = this.dialog.open(NumberBoxDialog, {
            data: {
                title: `Nombre de mesures - ${measureName}`,
                number: measureList.length === 0 ? 1 : measureList.length
            },
            width: '500px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: number | undefined) => {
            if (result === undefined || !Number.isFinite(result))
                return;

            this.updateExoticMeasureList(measureType, measureList, result);
        });
    }

    // addToIntervention() {
    //     this.SelectedMeasureList.forEach(x => {
    //         x.PumpWithBattery = this.WithBattery;
    //         x.Rush = this.WithExpressDelay;
    //     })
    //     this.StandardMeasureList.push(...this.SelectedMeasureList);
    //     this.SelectedMeasureList = [];
    //     this.MeasureList = [];
    //     this.table.renderRows();
    // }

    deleteMeasure(m: ClientMeasure) {
        _.remove(this.StandardMeasureList, x => x.SamplingId === m.SamplingId);
        this.table.renderRows();
    }

    deleteMeasureComplementary(m: ClientMeasure) {
        if (m.SamplingId)
            _.remove(this.ComplementaryMeasureList, x => x.SamplingId === m.SamplingId);
        else
            _.remove(this.ComplementaryMeasureList, x => x.localID === m.localID);
        this.ctable.renderRows();
    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }

    removeCompetence(comp: Competence): void {
        const index = this.Model.CompetenceList.indexOf(comp);

        if (index >= 0) {
            this.Model.CompetenceList.splice(index, 1);
        }
    }

    selectedComp(event: MatAutocompleteSelectedEvent): void {
        let newComp = new Competence();
        newComp.Name = event.option.viewValue;
        this.Model.CompetenceList.push(newComp);

        _.remove(this.AvailableMasterCompetenceList, x => x.Name === newComp.Name);
        this.compCtrl.setValue(null);
    }

    private _filter(value: Competence): Competence[] {
        const filterValue = value;

        return this.MasterCompetenceList.filter(x => x.Name.toLowerCase().includes(filterValue.Name));
    }

    addGeneric() {
        if (!this.SelectedGeneric)
            return;

        let newGeneric = Object.assign({}, this.SelectedGeneric)
        newGeneric.localID = (_.max(this.GenericList.map(x => x.localID)) ?? 0) + 1
        this.GenericList.push(newGeneric)
    }

    removeGeneric(m: ClientMeasure) {
        _.remove(this.GenericList, x => x.localID === m.localID)
    }

    CanChangeRequiredOn() {
        return this.Model.Status === EInterventionStatus.Done
    }

    CanOrder() {
        if (this.loadingTask.IsLoading)
            return;
        if (!this.IsDispatch && this.Model.RequiredOn &&
            ((this.WithStrictHours && this.minInterventionTime && this.maxInterventionTime) || (!this.WithStrictHours)))
            return true;
        if (this.IsDispatch && this.Model.RequiredOn && this.Model.SamplingAgencyName &&
            ((this.WithStrictHours && this.minInterventionTime && this.maxInterventionTime) || (!this.WithStrictHours))
            && this.StandardMeasureList.filter(x => this.IsProcess(x.MeasureReferenceCode)).every(x => StringTool.isNotNullOrEmpty(x.AreaMapName)))
            return true;
    }

    checkAndValidateOrder(continueOrder?: boolean) {
        // console.log(Temporal.Now.plainDateTimeISO().hour)
        // console.log(Temporal.Now.plainDateISO().add({ days: 1 }))
        // console.log(Temporal.PlainDate.from({ day: (this.Model.RequiredOn as any).date(), month: (this.Model.RequiredOn as any).month(), year: (this.Model.RequiredOn as any).year()}))
        if (this.IsCreation && !this.IsDispatch && Temporal.PlainDate.compare(
            Temporal.Now.plainDateISO().add({ days: 1 }),
            Temporal.PlainDate.from({ day: (this.Model.RequiredOn as any).date(), month: (this.Model.RequiredOn as any).month() + 1, year: (this.Model.RequiredOn as any).year() })) === 0
            && Temporal.Now.plainDateTimeISO().hour >= 12) {
            NotificationManager.handleWarning(`La date est trop proche, veuillez sélectionner une date ultérieure ou contactez-nous par téléphone au ${this.Strategy.Agency.Phone}`, this.snackBar)
            return;
        }

        if (!this.IsDispatch) {
            this.save(continueOrder);
            return;
        }

        let missingMeasures: ClientMeasure[] = [];

        // On cherche par Usage
        for (let i = EZoneUsage.PreWork; i < 4; i++) {
            this.StandardMeasureList.filter(x => x.ZoneUsage === i).forEach((x) => {

                let diff = _.differenceBy(
                    this.AvailableMeasureList.filter(y => !y.IsDepose && y.Frequency === EFrequency.Aucun && y.ZoneUsage === i && (y.CustomerRef ? y.CustomerRef === x.CustomerRef : y.ParentName === x.ParentName)),
                    this.StandardMeasureList.filter(y => !y.IsDepose && y.Frequency === EFrequency.Aucun && y.ZoneUsage === i && (y.CustomerRef ? y.CustomerRef === x.CustomerRef : y.ParentName === x.ParentName)),
                    z => z.SamplingId)
                if (diff) {
                    missingMeasures.push(...diff);
                }
            })
        }

        missingMeasures = _.uniqBy(missingMeasures, x => x.MeasureReferenceCode)
        // _.uniqBy(this.StandardMeasureList, x => x.CustomerRef)
        //     .forEach((x) => {

        //         let diff = _.differenceBy(this.AvailableMeasureList.filter(y => y.CustomerRef === x.CustomerRef), this.StandardMeasureList.filter(y => y.CustomerRef === x.CustomerRef), z => z.MeasureReferenceCode)
        //         if (diff) {
        //             missingMeasures.push(...diff);
        //         }
        //     })

        if (missingMeasures.length === 0) {
            this.save(continueOrder)
            return;
        }

        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            width: '666px',
            data: {
                message: `Etes-vous sûr de vouloir valider cette intervention en l'état ? N'auriez-vous pas oublié ces mesures \n${missingMeasures.map(x => `${x.MeasureReferenceName} (${x.ParentName})`).join(' ,\n')} ?`,
                withCancelButton: true
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.save(continueOrder)
            }
        });
    }

    save(continueOrder?: boolean) {

        this.Model.StrategyId = this.StrategyId;
        let list = [
            ...this.ComplementaryMeasureList, ...this.StandardMeasureList, ...this.LingetteMeasureList, ...this.MassifMeasureList,
            ...this.EauMeasureList, ...this.GenericList, ...this.AdductionMeasureList
        ]
        this.interventionService.updateOrder(this.Model, list)
            .pipe(
                filter((e: HttpResponse<any>) => e instanceof HttpResponse),
                finalize(() => this.loadingTask.deactivateLoading()),)
            .subscribe((event: HttpResponse<any>) => {
                if (event.status === 200) {

                    NotificationManager.handleSuccess('Commande effectuée !', this.snackBar);
                    if (continueOrder) {
                        this.Model = new Intervention();
                        this.Model.Id = this.route.snapshot.params['interventionId'];
                        this.minInterventionTime = undefined;
                        this.maxInterventionTime = undefined;
                        this.ComplementaryMeasureList = [];
                        this.StandardMeasureList = [];
                        this.LingetteMeasureList = [];
                        this.MassifMeasureList = [];
                        this.GenericList = [];
                        this.EauMeasureList = [];
                        this.AdductionMeasureList = [];
                        this.table.renderRows();
                        this.ctable.renderRows();
                    }
                    else
                        this.router.navigate([ENavigationRoute.IntenventionList]);
                } else if (event.status === 206) {
                    NotificationManager.handleWarning(event.body, this.snackBar);
                    this.router.navigate([ENavigationRoute.IntenventionList]);
                }
            })
    }

    // updateOrder() {
    //     let list = [...this.StandardMeasureList, ...this.LingetteMeasureList, ...this.MassifMeasureList, ...this.EauMeasureList]
    //     this.interventionService.updateOrder(this.Model, list).subscribe(x => {
    //         if (x) {
    //             // this.getOrderable();
    //             // this.Model.MeasureList = [];
    //             // this.table.renderRows();
    //             NotificationManager.handleSuccess('Commande modifiée !', this.snackBar);
    //             this.router.navigate([ENavigationRoute.IntenventionList]);
    //         }
    //     });
    // }

    deleteOrder(int: Intervention) {
        if (!this.IsDispatch) {
            let nextDay = 1

            if (Temporal.Now.plainDateISO().dayOfWeek == 6)
                nextDay = 2
            else if (Temporal.Now.plainDateISO().dayOfWeek == 7)
                nextDay = 3

            if (Temporal.Now.plainDateTimeISO().hour > 12)
                nextDay++

            console.log(Temporal.PlainDateTime.from(int.PlannedOn.toISOString().substring(0, int.PlannedOn.toISOString().length - 1)))
            console.log(Temporal.Now.plainDateTimeISO().add({ days: nextDay }))
            if (Temporal.PlainDateTime.compare(
                Temporal.Now.plainDateTimeISO().add({ days: nextDay }),
                Temporal.PlainDateTime.from(int.PlannedOn.toISOString().substring(0, int.PlannedOn.toISOString().length - 1))) === 1) {

                NotificationManager.handleWarning('Impossible de supprimer cette intervention car déjà planifiée pour le lendemain !', this.snackBar);
                return;
            }

            this.interventionService.deleteIntervention(int.Id, '').subscribe(x => {
                if (x) {
                    NotificationManager.handleSuccess('Intervention supprimée !', this.snackBar);
                    this.router.navigate([ENavigationRoute.IntenventionList]);
                }
            });
            return;
        }

        const dialogRef = this.dialog.open(EditTextBoxDialog, {
            width: '666px',
            data: {
                title: 'Veuillez saisir une justification',
                text: ''
            },
        });
        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.interventionService.deleteIntervention(int.Id, result).subscribe(x => {
                    if (x) {
                        NotificationManager.handleSuccess('Intervention supprimée !', this.snackBar);
                        this.router.navigate([ENavigationRoute.IntenventionList]);
                    }
                });
            }
        });
    }

    dateChanged(event: MatDatepickerInputEvent<Date>) {
        // const minTime = this.minInterventionTime.split(':');
        // this.Model.RequiredOn.setHours(Number(minTime[0]), Number(minTime[1]));
        // const maxTime = this.maxInterventionTime.split(':');
        // this.Model.RequiredOn.setHours(Number(maxTime[0]), Number(maxTime[1]));
    }
    onChange(withStrictHours: boolean) {

        if (!withStrictHours) {
            this.minInterventionTime = undefined;
            this.maxInterventionTime = undefined;
            this.Model.DisponibiliteClientList[0] = new DisponibiliteClient();
        }
    }

    addTimeToMinInterventionDate(event: string) {
        const time = event.split(':');

        this.Model.DisponibiliteClientList[0].From = new Date(this.Model.RequiredOn);
        this.Model.DisponibiliteClientList[0].From.setHours(Number(time[0]), Number(time[1]))

        this.setMinTime();
    }

    setMinTime() {
        this.minInterventionTime = `${this.Model.DisponibiliteClientList[0].From.getHours()}:${this.Model.DisponibiliteClientList[0].From.getMinutes()}`;

        this.Model.DisponibiliteClientList[0].To = new Date(this.Model.DisponibiliteClientList[0].From.getTime() + (1000 * 60 * 15));
        this.maxInterventionTime = `${this.Model.DisponibiliteClientList[0].To.getHours()}:${this.Model.DisponibiliteClientList[0].To.getMinutes()}`;

    }

    addTimeToMaxInterventionDate(event: string) {
        const time = event.split(':');

        this.Model.DisponibiliteClientList[0].To.setHours(Number(time[0]), Number(time[1]));
        this.setMaxTime();
    }

    setMaxTime() {
        this.maxInterventionTime = `${this.Model.DisponibiliteClientList[0].To.getHours()}:${this.Model.DisponibiliteClientList[0].To.getMinutes()}`;
    }

    openDocumentDialog() {
        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { 
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) { // result = file name
                result.forEach(name => {
                    this.Model.OrderFileName = name;
                });
            }
        });
    }
}
